import React from "react";
import { Link } from "react-router-dom";
import logoImg from "images/logo-min.webp";

export interface LogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
  isDark?: boolean;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  className = "w-20",
}) => {
  return (
    <Link
      to="/"
      className={`ttnc-logo inline-block focus:outline-none focus:ring-0 ${className}`}
    >
      <img
        className="block max-h-10 sm:max-h-12 w-auto"
        src={img}
        alt="BCR LTD Logo"
      />
    </Link>
  );
};

export default Logo;
